import { Theme } from "@mui/material";
import { IFormDate } from "../../../services/custom-forms-data-service/TemplateModels";
import FormDatePicker from "../../forms/form-date-picker/FormDatePicker";
import FormProperty from "../../forms/form-property/FormProperty";
import { SxProps } from "@mui/system";

export type CustomFormDateProps = {
    date: IFormDate;
    key?: React.Key | null | undefined;
    sx?: SxProps<Theme>;
};

export default function CustomFormDate({
    date,
    key,
    sx
}: CustomFormDateProps) {

     return (

        <FormProperty key={key} sx={sx}>
            <FormDatePicker
                id={date.id}
                name={date.name}
                label={date.label}
                readOnly={date.readOnly}
                ariaLabel={date.ariaLabel}            
                //views={["month", "year"]}
                rules = {date.rules}
                views = {date.views}
                sx={{width: '100%'}}
            />
        </FormProperty>

    );
}
